import React from 'react';
import classnames from 'classnames';

import ClickableDiv from 'dpl/common/components/ClickableDiv';

interface MediaMosaicGridProps<T> {
  items: T[];
  // Tiles beyond this are dropped; callers show a "+N" for them.
  maxTiles: number;
  // The tile's contents: the image or video poster, a play badge, a "+N"
  // scrim. Kept with the caller because surfaces differ on all three.
  renderTile: (item: T, index: number) => React.ReactNode;
  onTileClick: (index: number, e: React.SyntheticEvent) => void;
  keyFor?: (item: T, index: number) => string;
  className?: string;
  style?: React.CSSProperties;
  // Extra grid children, e.g. a "+N" button positioned over the whole grid.
  children?: React.ReactNode;
}

// The mosaic's shape: how many tiles to show and which cell each lands in.
// Everything visual — box size, aspect ratio, tile chrome — belongs to the
// caller; see media-mosaic-grid.scss.
export default function MediaMosaicGrid<T>({
  items,
  maxTiles,
  renderTile,
  onTileClick,
  keyFor,
  className,
  style,
  children
}: MediaMosaicGridProps<T>) {
  const tiles = items.slice(0, maxTiles);

  return (
    <div
      className={classnames(
        'MediaMosaicGrid',
        `MediaMosaicGrid--count-${tiles.length}`,
        className
      )}
      style={style}
    >
      {tiles.map((item, index) => (
        <ClickableDiv
          key={keyFor ? keyFor(item, index) : index}
          className="MediaMosaicGrid__tile relative"
          onClick={e => onTileClick(index, e)}
        >
          {renderTile(item, index)}
        </ClickableDiv>
      ))}
      {children}
    </div>
  );
}
